module.exports = require('domify');


// WEBPACK FOOTER //
// ./~/min-dom/lib/domify.js